export default __webpack_public_path__ + "static/media/UniLogo1.57d9d0ad.svg";